module.exports = __webpack_public_path__ + "static/img/log_1.a8c79aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/log_1.jpg
// module id = mYeB
// module chunks = 1